import { render } from "./MFITTRefundSeats.vue?vue&type=template&id=6bf8ba42&scoped=true"
import script from "./MFITTRefundSeats.vue?vue&type=script&lang=js"
export * from "./MFITTRefundSeats.vue?vue&type=script&lang=js"

import "./MFITTRefundSeats.vue?vue&type=style&index=0&id=6bf8ba42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bf8ba42"

export default script